function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  position: relative;\n  align-items: center;\n  padding: 18px 15px;\n  color: ", ";\n  &.selected {\n    background-color: ", ";\n    .name {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import { defaultTheme } from '../../../utils';
import CustomNav from '../../atoms/CustomNav';
import MenuIcon from './MenuIcon';
import PropTypes from 'prop-types';
var MenuItemWrapper = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.text.bodyTextDark;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.primaryBackground;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.primaryColor;
});
export var isCurrentUrl = function isCurrentUrl(path, location) {
  return location.pathname === path;
};

var MenuItem = function MenuItem(_ref4) {
  var name = _ref4.name,
      iconName = _ref4.iconName,
      link = _ref4.link,
      type = _ref4.type,
      tag = _ref4.tag,
      redirect = _ref4.redirect,
      selectedIconName = _ref4.selectedIconName,
      onClickHandler = _ref4.onClickHandler,
      rest = _objectWithoutPropertiesLoose(_ref4, ["name", "iconName", "link", "type", "tag", "redirect", "selectedIconName", "onClickHandler"]);

  var location = window.location;
  return /*#__PURE__*/React.createElement(MenuItemWrapper, _extends({}, rest, {
    className: "" + (isCurrentUrl(link, location) ? 'selected' : '')
  }), /*#__PURE__*/React.createElement(MenuIcon, {
    type: type,
    name: isCurrentUrl(link, location) ? selectedIconName : iconName,
    tag: tag
  }), redirect ? /*#__PURE__*/React.createElement("div", {
    className: "name"
  }, /*#__PURE__*/React.createElement(CustomNav, {
    variant: 'menu-item',
    text: name,
    to: link
  })) : /*#__PURE__*/React.createElement("div", {
    className: "name",
    onClick: function onClick() {
      return onClickHandler(link);
    }
  }, name));
};

MenuItem.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string,
  iconName: PropTypes.string,
  selectedIconName: PropTypes.string,
  tag: PropTypes.string,
  link: PropTypes.string,
  type: PropTypes.string,
  redirect: PropTypes.bool,
  onClickHandler: PropTypes.func
} : {};
MenuItem.defaultProps = {
  theme: defaultTheme,
  tag: null,
  iconName: '',
  name: '',
  link: '',
  type: 'svg',
  redirect: false
};
export default MenuItem;